import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

type ProtectedRouteProps = {
  children: React.ReactNode;
  requireAdmin?: boolean;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    // Show loading spinner while checking auth state
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to landing page and signal to open login modal
    return <Navigate to="/" state={{ from: location, openLogin: true }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    // Redirect to home page if user is not an admin
    return <Navigate to="/" state={{ openLogin: true }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
